import type { MouseEvent } from 'react'
import { RadioMark, StatusDot, StatusOptionButton } from '../styled-components'
import type { StatusDotToken } from '../styled-components'

interface StatusOptionProps {
  label: string
  selected: boolean
  dot: StatusDotToken
  onClick: (event: MouseEvent) => void
}

const StatusOption = ({ label, selected, dot, onClick }: StatusOptionProps) => (
  <StatusOptionButton type='button' aria-pressed={selected} $selected={selected} onClick={onClick}>
    <RadioMark $selected={selected} aria-hidden='true' />
    {label}
    <StatusDot $token={dot} aria-hidden='true' />
  </StatusOptionButton>
)

export default StatusOption
